import { createAsyncThunk } from "@reduxjs/toolkit";
import { getProjectProgressList } from "../../Api/ProjectProgress/projectProgressApi";
import { mapProjectProgresses } from "../Types/ProjectProgress/ProjectProgress";
import { getProjectProgressServiceList } from "../../Api/ProjectProgress/projectProgressServiceApi";
import { mapProjectProgressServices } from "../Types/ProjectProgress/ProjectProgressService";

// Fetch project progress data
export const fetchProjectProgressData = createAsyncThunk(
    'fetchProjectProgressData',
    async (_, { rejectWithValue }) => {
        try {
            const response = await getProjectProgressList();
            if (response.status) {
                return mapProjectProgresses(response.body);
            } else {
                return rejectWithValue(response.error);
            }
        } catch (error: any) {
            return rejectWithValue('Failed to fetch project progress data');
        }
    }
);

// Fetch project progress service data
export const fetchProjectProgressServiceData = createAsyncThunk(
    'fetchProjectProgressServiceData',
    async (_, { rejectWithValue }) => {
        try {
            const response = await getProjectProgressServiceList();
            if (response.status) {
                return mapProjectProgressServices(response.body);
            } else {
                return rejectWithValue(response.error);
            }
        } catch (error: any) {
            return rejectWithValue('Failed to fetch project progress service data');
        }
    }
);